import React, { useState } from 'react';
import ContentApp from '../ContentApp';
import Header from '../Common/Header/Header';
import styles from './Invite.module.css';
import { Toast } from '../Common/Toast/Toast';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import CopyIconGroup from '../icons/CopyIconGroup';
const Invite = () => {
  const app = useSelector((state) => state.app);
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation();
  const user = useSelector((state) => state.associates.user);
  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: app.name,
          url: user.homeSiteUrl,
        });
      } else {
        console.warn('Web Share API not supported in this browser.');
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
  };

  return (
    <>
      <Header />
      <ContentApp>
        <div className='semi-bold' style={{ fontSize: '18px' }}>
          {t('hereIsYourLink')}
        </div>
        <p className='mt-3 text-secondary'>
          {t('shareThisLinkWithYourAccount')}
          <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>
            {t('connectedAccountslist')}
          </span>
        </p>

        <div className={` ${styles.container} mt-4`}>
          <div className={styles.boxLink}>{user.homeSiteUrl}</div>
          <div className={styles.copy} onClick={handleShare}>
            <CopyIconGroup size={22} fillColor={'#fff'} />
          </div>
        </div>
        {copied && (
          <Toast
            bottom={'15px'}
            zIndex={100000}
            type={'success'}
            message={t('linkCopied')}
            delay={3}
          />
        )}
      </ContentApp>
    </>
  );
};

export default Invite;
